import React, { useState, useRef, useCallback, useEffect } from 'react';
import PermButton from '../../core/utils/PermButton';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectFilteredVendors,
  selectVendorFilterVisible,
  selectVendorLoading,
  selectfetchVendorLoading
} from './store/selectors';
import VirtualList from '../components/VirtualList';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { Edit, Trash2 } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { deleteVendor } from './store/slice';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const VendorTile = ({ onEditVendor }) => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const vendorTileRef = useRef(null);
  
  const filteredVendors = useSelector(selectFilteredVendors);
  const isLoading = useSelector(selectVendorLoading);
  const filterVisible = useSelector(selectVendorFilterVisible);
  const headerVisible = useSelector(isHeaderVisible);
  const isFetchDataLoading = useSelector(selectfetchVendorLoading);

  const updateColumnSettings = useCallback(() => {
    if (vendorTileRef.current) {
      const width = vendorTileRef.current.offsetWidth;
      let columns = 6;
      if (width < 576) {
        columns = 1;
      } else if (width < 768) {
        columns = 3;
      } else if (width < 992) {
        columns = 5;
      } else {
        columns = 6;
      }
      
      const newColumnWidth = Math.max(width / columns, 200);
      setColumnCount(columns);
      setColumnWidth(newColumnWidth);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings, filterVisible, headerVisible]);

  const itemData = filteredVendors.map(vendor => <VendorTileItem vendor={vendor} onEditVendor={onEditVendor} key={vendor.id} />);
  const rowCount = Math.ceil(filteredVendors.length / columnCount);

  return (
    <div
      className={`shipment-tile-body ${filterVisible ? 'filter-visible' : ''} ${!headerVisible ? 'header-collapsed' : ''}`}
      ref={vendorTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={rowCount}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150}
        />
      }
    </div>
  );
};

const VendorTileItem = ({ vendor, onEditVendor }) => {
  const dispatch = useDispatch();

  const handleEdit = (vendor) => {
    if (onEditVendor) {
      onEditVendor(vendor);
    }
  };

  const handleDelete = (vendor) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteVendor(vendor.id));
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        )
      }
    })
  };

  return (
    <div key={vendor.id} className="vendor-tile">
      <div
        className={`card p-3 m-2 ${vendor.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions" style={{ textAlign: 'right' }}>
          <ButtonGroup size="sm">
            <PermButton perm="MASTERS.VENDOR.EDIT">
              <Button variant="light" onClick={() => handleEdit(vendor)}>
                <Edit size={16} />
              </Button>
            </PermButton>
            <PermButton perm="MASTERS.VENDOR.DELETE">
              <Button variant="light" onClick={() => handleDelete(vendor)}>
                <Trash2 size={16} />
              </Button>
            </PermButton>
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0 truncate-2lines" title={vendor.vendorName}>
                {vendor.vendorName || 'No Name'}
              </h6>
            </div>
          </div>
        </div>
        <div className="mt-1">
          <span
            className="badge"
            style={{
              backgroundColor: vendor.backGroundColor || '#e0e0e0',
              color: vendor.textColor || '#000000',
            }}
          >
            {vendor.status || 'N/A'}
          </span>
        </div>
        <div className="mt-1">
          <small className="text-muted">
            {vendor.location && `${vendor.location} • `}
            {vendor.contactPerson || 'N/A'}
          </small>
        </div>
      </div>
    </div>
  );
};

export default VendorTile; 